import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CountryDTO } from '../../../shared/country-dto';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  countries: CountryDTO[];

  constructor(private http: HttpClient) { }

  getCountries() {
    if (this.countries && this.countries.length) {
      return of(this.countries);
    } else {
      return this.http.get<CountryDTO[]>('/api/country')
        .pipe(map(countries => { this.countries = countries; return countries; }));
    }
  }
}
